import Area from '@/components/Area';
import { shaderMaterial, useTexture } from '@react-three/drei';
import { Canvas, extend, ReactThreeFiber, useFrame } from '@react-three/fiber';
import * as React from 'react';
import img1 from './Img1.jpg';
import img2 from './Img2.jpg';
import displacement10 from './displacement/10.jpg';
import displacement11 from './displacement/11.jpg';
import displacement12 from './displacement/12.jpg';
import displacement13 from './displacement/13.jpg';
import * as THREE from 'three';
import vert from './camera.vert';
import frag from './image-displacement.frag';
const DISPLACEMENT_IMAGES = [displacement10.src, displacement11.src, displacement12.src, displacement13.src];

type TextureChangeShaderProps = {
  uTexture1?: THREE.Texture;
  uTexture2?: THREE.Texture;
  uDisplacement?: THREE.Texture;
  blendRatio?: number;
};

const DisplacementShader = shaderMaterial(
  {
    uTexture1: null,
    uTexture2: null,
    uDisplacement: null,
    blendRatio: 0,
  },
  vert,
  frag
);

extend({ DisplacementShader });

declare global {
  namespace JSX {
    interface IntrinsicElements {
      displacementShader: ReactThreeFiber.Node<
        typeof DisplacementShader & JSX.IntrinsicElements['shaderMaterial'],
        TextureChangeShaderProps
      > &
        TextureChangeShaderProps;
    }
  }
}

function FadingImage({ displacementIndex = 0 }: { displacementIndex?: number }) {
  const [textureImg1, textureImg2, ...displacements] = useTexture([
    img1.src,
    img2.src,
    displacement10.src,
    displacement11.src,
    displacement12.src,
    displacement13.src,
  ]);
  const [hovered, setHovered] = React.useState(false);
  const ref = React.useRef<JSX.IntrinsicElements['textureChangeShader']>(null);
  useFrame(() => {
    const shader = ref.current;
    if (!shader) return;
    shader.blendRatio = THREE.MathUtils.lerp(shader.blendRatio || 0, hovered ? 1 : 0, 0.035);
  });
  // console.log('FadingImage', { hovered, blendRatio: ref.current?.blendRatio });
  return (
    <mesh onPointerEnter={() => setHovered(true)} onPointerLeave={() => setHovered(false)}>
      <planeGeometry />
      <displacementShader
        ref={ref as any}
        uTexture1={textureImg1}
        uTexture2={textureImg2}
        uDisplacement={displacements[displacementIndex]}
      />
    </mesh>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  const [displacementIndex, setDisplacementIndex] = React.useState(0);

  return (
    <>
      <Area>
        {() => (
          <>
            <Canvas camera={{ position: [0, 0, 2], fov: 50 }}>
              <ambientLight />
              <FadingImage displacementIndex={displacementIndex} />
            </Canvas>
          </>
        )}
      </Area>
      <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        {DISPLACEMENT_IMAGES.map((src, index) => (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            css={{
              width: '4rem',
              border: '2px solid black',
              ...(index === displacementIndex ? { borderColor: 'red' } : {}),
            }}
            key={index}
            src={src}
            onClick={() => setDisplacementIndex(index)}
          />
        ))}
      </div>
    </>
  );
}

export default React.memo(App01);
